import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { INBOX_FILTERS } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import SectionFilter from '../SectionFilter';

function NewsFilters({ t, onChange }) {
  const [filter, setFilter] = useState('');
  const handleChange = newFilter => {
    setFilter(newFilter);
    onChange(newFilter);
  };

  const options = [{ id: '', text: t('all') }].concat(
    INBOX_FILTERS.map(type => ({
      id: type,
      text: t(`inbox_filter_${type}`),
    })),
  );

  return (
    <SectionFilter
      id="newsFilter"
      items={options}
      onChange={handleChange}
      value={filter}
    />
  );
}

NewsFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default translate(NewsFilters);
